Object.defineProperty(exports,"__esModule",{value:true});exports.useLinking=void 0;var useLinking=function useLinking(){return{urlString:window.location.toString()};};exports.useLinking=useLinking;
//# sourceMappingURL=useLinking.web.js.map